import React from 'react';
import { AlertWithIcon } from '../atom/alert/AlertWithIcon';

export const MaintenanceAlert = () => {
  return (
    <AlertWithIcon
      status="warning"
      subtitle="ただいまメンテナンス中です。"
      text="ご不便をおかけし、申し訳ございません。\nメンテナンス作業が完了するまで今しばらくお待ちください。"
    />
  );
};
